import { useCallback } from "react";
import useGameStore from "@store/useGameStore";
import { getGame } from "@/api/gameApi";

/**
 * Hook que PROVEE la lógica de carga para la vista del juego.
 */
export default function useGame() {

    const fetchGameById = useCallback(async (gameId) => {
        if (!gameId) {
            console.warn("[useGame] No se encontró gameId, saltando la carga.");
            return;
        }

        useGameStore.getState().setLoading(true);

        try {
            await getGame(gameId);
        } catch (err) {
            useGameStore.getState().setError(err.userMessage || "No se pudieron cargar los datos del juego.");
        }
    }, []);

    // El hook solo devuelve la función.
    return { fetchGameById };
}